"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function getCloudinaryImage({ public_id, cloud, transform, }) {
    const params = [cloud, transform, public_id].filter(x => x).join('/');
    return `//res.cloudinary.com/${params}`;
}
exports.getCloudinaryImage = getCloudinaryImage;
function getImage(image) {
    if (image.cloudinary) {
        return getCloudinaryImage(image.cloudinary);
    }
    return image.src;
}
exports.getImage = getImage;
//# sourceMappingURL=image.js.map